var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"network-status-helper-components-1-main-page"},[_c('NetworkStatusHelperComponents2Header'),_c('NetworkStatusHelperComponents3ResourceList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }